// import Vue from "vue";
import Vuex from 'vuex';
import index from './modules/index';
import login from './modules/login';
import language from './modules/language';

export default new Vuex.Store({
    modules: {
        index,
        login,
        language
    }
});